import { services } from "../../../../constants";

export default async function verifyLandline() {
    const url = `${this.backendHosts.auth}${services.landlineVerification}`;
    try {
      const response = await this.http.post(url);
      return response;
    } catch (error) {
      this.handleErrorResponse(error);
    }
  }